import { render, staticRenderFns } from "./BookingsPage.vue?vue&type=template&id=2881f9a4&scoped=true"
import script from "./BookingsPage.vue?vue&type=script&lang=js"
export * from "./BookingsPage.vue?vue&type=script&lang=js"
import style0 from "./BookingsPage.vue?vue&type=style&index=0&id=2881f9a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2881f9a4",
  null
  
)

export default component.exports